<template>
    <div>
        <form @submit.prevent="submit_form" autocomplete="off">
            <div class="row">
                <div class="col-md-8 personal-fields">
                    <div class="row">
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Company <span class="required-indicator">*</span></label>
                            <input :disabled="isSesSupport" type="text" class="form-control" required ref="company" name="company" v-model="model.company">
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Key Person Title <span class="required-indicator">*</span></label>
                            <input type="text" class="form-control" required ref="title" name="title" v-model="model.title">
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>First Name <span class="required-indicator">*</span></label>
                            <input type="text" class="form-control" required ref="first_name" name="first_name" v-model="model.first_name">
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Last Name <span class="required-indicator">*</span></label>
                            <input type="text" class="form-control" required ref="last_name" name="last_name" v-model="model.last_name">
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Office Phone <span class="required-indicator">*</span></label>
                            <input type="text" class="form-control" required ref="phone" name="phone" v-model="model.phone">
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Email <span class="required-indicator">*</span></label>
                            <input type="email" class="form-control" required ref="email" name="email" v-model="model.email">
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Fax</label>
                            <input :disabled="isSesSupport" type="text" class="form-control" name="fax" v-model="model.fax">
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Cell Phone</label>
                            <input type="text" class="form-control" name="cellphone" v-model="model.cellphone">
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Street Address <span class="required-indicator">*</span></label>
                            <input :disabled="isSesSupport" type="text" class="form-control" required ref="address" name="address" v-model="model.address">
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Country <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="country" name="country" v-model="model.country">
                                <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>City <span class="required-indicator">*</span></label>
                            <input :disabled="isSesSupport" type="text" class="form-control" required ref="city" name="city" v-model="model.city">
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>State/Province <span class="required-indicator">*</span></label>
                            <input :disabled="isSesSupport" type="text" class="form-control" required ref="state" name="state" v-model="model.state">
                        </div>
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Zip Code <span class="required-indicator">*</span></label>
                            <input :disabled="isSesSupport" type="text" class="form-control" required ref="zipcode" name="zipcode" v-model="model.zipcode">
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Username</label>
                            <input type="text" class="form-control" required :disabled="user_id != 'new'" ref="username" name="username" v-model="model.username">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-12">
                            <button :disabled="isSendingResetLink || user_id === 'new' || isSubmitting" class="btn" type="button" @click.prevent="handleSendResetLink">
                                <span v-if="isSendingResetLink">Sending reset link...</span>
                                <span v-else>Send Password Reset Link</span>
                            </button>
                        </div>
                    </div>
                    <hr>
                    <div class="row" v-if="false">
                        <div class="form-group col-md-6 col-xs-12">
                            <label>Components</label>
                            <ul class="ul-components">
                                <li><label><input type="checkbox" :checked="model.components.length == components.length" @click="select_all_components"> Toggle All</label></li>
                                <li v-for="(component, key) in components" :key="key"><label><input type="checkbox" :checked="model.components.indexOf(component.value) != -1" :value="component.value" @click="select_component"> {{ component.name }}</label></li>
                            </ul>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="form-group col-md-12 col-xs-12">
                            <label>Special PDFs</label>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 60%;">PDF</th>
                                        <th style="width: 30%;">Orientation</th>
                                        <th style="witdh: 10%;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(pdf, key) in special_pdfs" :key="key">
                                        <td>
                                            <input type="hidden" v-model="pdf.id">
                                            <template v-if="!pdf.path">
                                                <input :disabled="isSesSupport" type="file" :ref="`special_pdf_file${key}`" class="form-control" accept="application/pdf" :required="key > 0">
                                            </template>
                                            <template v-else>
                                                <div class="pdf-link">
                                                    <div class="d-flex align-items-center">
                                                        <a :disabled="isSesSupport" :href="pdf.path" target="_blank"><span class="fa fa-file-pdf"></span></a>
                                                        <button :disabled="isSesSupport" class="btn btnEditFile ml-2" type="button" @click="pdf.path = ''"><span class="fa fa-edit"></span></button>
                                                    </div>
                                                    <a :disabled="isSesSupport" :href="pdf.path" target="_blank" class="mt-2 d-block">{{ pdf.path.replace(/^.*[\\\/]/, '') }}</a>
                                                </div>
                                            </template>
                                        </td>
                                        <td>
                                            <select :disabled="isSesSupport" class="form-control" v-model="pdf.orientation">
                                                <option value="L">Landscape</option>
                                                <option value="P">Portrait</option>
                                            </select>
                                        </td>
                                        <td>
                                            <div class="row-btns">
                                                <button :disabled="isSesSupport" class="btn btnAddPdfRow" type="button" @click="add_pdf_row('special')"><span class="fa fa-plus"></span></button>
                                                <button :disabled="isSesSupport" class="btn btnRemovePdfRow" type="button" @click="remove_pdf_row('special', pdf.id, key)"><span class="fa fa-close"></span></button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="form-group col-md-12 col-xs-12">
                            <label>Machine Types PDFs</label>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 30%;">Machine</th>
                                        <th style="width: 35%;">PDF</th>
                                        <th style="width: 25%;">Orientation</th>
                                        <th style="width: 10%;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(pdf, key) in machine_type_pdfs" :key="key">
                                        <td><input :disabled="isSesSupport" type="text" class="form-control" v-model="pdf.machine" :required="key > 0"></td>
                                        <td>
                                            <input type="hidden" v-model="pdf.id">
                                            <template v-if="!pdf.path">
                                                <input :disabled="isSesSupport" type="file" :ref="`machine_type_pdf_file${key}`" class="form-control" accept="application/pdf" :required="key > 0">
                                            </template>
                                            <template v-else>
                                                <div class="pdf-link">
                                                    <div class="d-flex align-items-center">
                                                        <a :disabled="isSesSupport" :href="pdf.path" target="_blank"><span class="fa fa-file-pdf"></span></a>
                                                        <button :disabled="isSesSupport" class="btn btnEditFile ml-2" type="button" @click="pdf.path = ''"><span class="fa fa-edit"></span></button>
                                                    </div>
                                                    <a :disabled="isSesSupport" :href="pdf.path" target="_blank" class="mt-2 d-block">{{ pdf.path.replace(/^.*[\\\/]/, '') }}</a>
                                                </div>
                                            </template>
                                        </td>
                                        <td>
                                            <select :disabled="isSesSupport" class="form-control" v-model="pdf.orientation">
                                                <option value="L">Landscape</option>
                                                <option value="P">Portrait</option>
                                            </select>
                                        </td>
                                        <td>
                                            <div class="row-btns">
                                                <button :disabled="isSesSupport" class="btn btnAddPdfRow" type="button" @click="add_pdf_row('machine_type')"><span class="fa fa-plus"></span></button>
                                                <button :disabled="isSesSupport" class="btn btnRemovePdfRow" type="button" @click="remove_pdf_row('machine_type', pdf.id, key)"><span class="fa fa-close"></span></button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <hr>
                    <div class="row mt-2">
                        <div class="col-md-12">
                            <div class="button-group">
                                <button class="btn btn-black" type="submit" :disabled="isSubmitting">
                                    <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                                    <template v-else-if="user_id == 'new'">Save</template>
                                    <template v-else>Update</template>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 admin-fields" v-if="managers">
                    <h3>Admin Controlled Fields</h3>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <label>Special Role</label>
                            <select :disabled="isSesSupport" class="form-control" ame="role" v-model="model.special_role" @change="specialDefaults">
                                <option></option>
                                <option v-for="(role, p) in special_roles" :key="p" :value="role.role">{{ role.name }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Primary Role <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="role" name="role" v-model="model.role">
                                <option v-for="(role, p) in roles" :key="p" :value="role.role">{{ role.name }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Secondary Role</label>
                            <select :disabled="isSesSupport" class="form-control" name="role" v-model="model.extra_roles" multiple>
                                <option v-for="(role, p) in roles" :key="p" :value="role.role" :selected="model.extra_roles && model.extra_roles.includes(role.role)">{{ role.name }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12" v-if="model.role == 'project-manager'">
                            <label>Can Approve</label>
                            <select :disabled="isSesSupport" class="form-control" required ref="can_approve" name="can_approve" v-model="model.can_approve">
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Customer Code</label>
                            <input :disabled="isSesSupport" type="text" class="form-control" required ref="customer_code" name="customer_code" v-model="model.customer_code">
                        </div>
                        <div class="form-group col-md-12" v-if="!ses_roles.includes(model.role)">
                            <label>Customer BP Code</label>
                            <input :disabled="isSesSupport" type="text" class="form-control" required ref="bp_code" name="bp_code" v-model="model.bp_code">
                        </div>
                        <div class="form-group col-md-12" v-if="model.role != 'project-manager'">
                            <label>Project Manager</label>
                            <select :disabled="isSesSupport" class="form-control" required ref="pm" name="pm" v-model="model.pm">
                                <option v-for="(pm, p) in pms" :key="p" :value="pm.username">{{ pm.username }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Manager</label>
                            <select :disabled="isSesSupport" class="form-control" name="managers" v-model="model.managers">
                                <option v-for="(pm, p) in managers" :key="p" :value="pm.username">{{ pm.username }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Distributor</label>
                            <select :disabled="isSesSupport" class="form-control" name="distributor" v-model="model.distributor">
                                <option value=""></option>
                                <option v-for="(pm, p) in distributors" :key="p" :value="pm.username">{{ pm.username }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Email report <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="receive_email" name="receive_email" v-model="model.receive_email">
                                <option value="1">Enabled</option>
                                <option value="0">Disabled</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Purchasing Type <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="can_purchase" name="can_purchase" v-model="model.can_purchase">
                                <option value="1">Can Purchase (Own and Subs)</option>
                                <option value="2">Own Projects Only</option>
                                <option value="3">Request Purchase Only</option>
                                <option value="4">Requested Only</option>
                                <option value="0">Not Allowed</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Pricing <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="pricing" name="pricing" v-model="model.pricing">
                                <option value="1">Enabled</option>
                                <option value="0">Disabled</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Drop Ship Fee <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="add_dropship" name="add_dropship" v-model="model.add_dropship">
                                <option value="0">US Logic</option>
                                <option value="1">Non-US Logic</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>CAD File Download <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="download_cad" name="download_cad" v-model="model.download_cad">
                                <option value="0">Not Allowed</option>
                                <option value="1">Allowed</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>3D File Download <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="download_3d" name="download_3d" v-model="model.download_3d">
                                <option value="0">Not Allowed</option>
                                <option value="1">Allowed</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>5001 Machines <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="allow_5001" name="allow_5001" v-model="model.allow_5001">
                                <option value="0">Not Allowed</option>
                                <option value="1">Allowed</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>KEB Green <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="kebgrn" name="kebgrn" v-model="model.kebgrn">
                                <option value="0">Not Allowed</option>
                                <option value="1">Allowed</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Stock Option <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="no_stock" name="no_stock" v-model="model.no_stock">
                                <option value="1">Not Allowed</option>
                                <option value="0">Allowed</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Go Custom when Gearless with Otis Drive <span class="required-indicator">*</span></label>
                            <select :disabled="isSesSupport" class="form-control" required ref="custom_otis_gearless" name="custom_otis_gearless" v-model="model.custom_otis_gearless">
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Add "Special Order Paint"</label>
                            <select :disabled="isSesSupport" class="form-control" required ref="special_paint" name="special_paint" v-model="model.special_paint">
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Discount (%)</label>
                            <input :disabled="isSesSupport" type="number" min="0" max="100" class="form-control" required ref="discount" name="discount" v-model="model.discount">
                        </div>
                        <div class="form-group col-md-12">
                            <label>Sales Employee</label>
                            <input :disabled="isSesSupport" type="text" min="0" max="100" class="form-control" v-model="model.sales">
                        </div>
                        <div class="form-group col-md-12">
                            <label>Lead Time <span class="required-indicator">*</span></label>
                            <input :disabled="isSesSupport" type="number" min="0" max="99" class="form-control" v-model="model.lead_time" required>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Minimum Rope Number <span class="required-indicator">*</span></label>
                            <input :disabled="isSesSupport" type="number" min="0" max="99" class="form-control" v-model="model.min_rope" required>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Pads on Floors</label>
                            <select :disabled="isSesSupport" ref="can_pads_on_floors" v-model="model.can_pads_on_floors" class="form-control" name="can_pads_on_floors" required>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Dura Lift Sheave</label>
                            <select :disabled="isSesSupport" ref="dura_lift_sheave" v-model="model.dura_lift_sheave" class="form-control" name="dura_lift_sheave" required>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Wire Rope & Comp Default</label>
                            <select ref="wire_rope" v-model="model.wire_rope" class="form-control" name="wire_rope" required>
                                <option value="1">Checked</option>
                                <option value="0">Not Checked</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="setting_hpl">Hyperion Price List
                                <input
                                    id="setting_hpl"
                                    ref="hyperion_price_list"
                                    v-model="model.hyperion_price_list"
                                    :checked="model.hyperion_price_list === 1"
                                    type="checkbox"
                                    name="setting_hpl"
                                    class="setting_hpl"
                                    @change="handleHplChange">
                            </label>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Consulted Rope Manufacturer</label>
                            <select :disabled="isSesSupport" ref="consulted_rope_manufacturer" v-model="model.consulted_rope_manufacturer" class="form-control" name="consulted_rope_manufacturer" required>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Quote TK Machines</label>
                            <select :disabled="isSesSupport" ref="tk_machine" v-model="model.tk_machine" class="form-control" name="tk_machine" required>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Always Add Rope Lubricator</label>
                            <select :disabled="isSesSupport" ref="rope_lubricator_option" v-model="model.rope_lubricator_option" class="form-control" name="rope_lubricator_option" required>
                                <option value="No">No</option>
                                <option value="RLU">RLU</option>
                                <option value="RPLU">RPLU</option>
                            </select>
                        </div>
                        <div class="form-group col-md-12">
                            <label>Quote Validity</label>
                            <input :disabled="isSesSupport" type="number" min="0" max="1000" class="form-control" required ref="quote_validity" name="quote_validity" v-model="model.quote_validity">
                        </div>
                        <div class="form-group col-md-12">
                            <label>Allowable # of trips for Rope Life</label>
                            <input :disabled="isSesSupport" type="number" min="0" class="form-control" required ref="ropelife_trips" name="ropelife_trips" v-model="model.ropelife_trips">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    name: 'user-profile',
    data() {
        return {
            apiUrl: '/api/',
            user_id: null,
            isSubmitting: false,
            countries: window.countries,
            xxx: {},
            managers: false,
            pms: false,
            roles: false,
            distributors: false,
            model: {
                company: 'SES',
                title: 'Mr.',
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                fax: '',
                cellphone: '',
                address: '',
                country: 'USA',
                city: 'Memphis',
                state: 'Tennessee',
                zipcode: '38118',
                customer_code: '',
                bp_code: 'C00801',
                role: 'customer',
                extra_roles: '',
                receive_email: '1',
                pricing: '1',
                add_dropship: '0',
                cad_download: '1',
                export_3D: '1',
                allow_5001: '0',
                kebgrn: '0',
                discount: '0',
                components: [],
                lead_time: '14',
                min_rope: '',
                can_pads_on_floors: 0,
                tk_machine: 0,
                rope_lubricator_option: 'No',
                quote_validity: 90,
                ropelife_trips: 0
            },
            showPassword: false,
            password: '',
            password_v: '',
            ses_roles: [
                'administrator',
                'approver',
                'project-manager',
                'ses-view',
                'ses-support',
                'super-user',
            ],
            special_roles: [
                { role : 'otis-branch', name : 'Otis Branch' },
                { role : 'schindler-branch', name : 'Schindler Branch' },
                { role : 'tke-branch', name : 'TKE Branch' },
                { role : 'kone-branch', name : 'Kone Branch' },
                { role : 'otis-region', name : 'Otis Region' },
            ],
            role_defaults: {
                'otis-branch' : {
                    role : 'customer',
                    custom_otis_gearless : 1,
                    download_cad : 1,
                    download_3d : 0,
                    no_stock : 0,
                    can_purchase : 2,
                    allow_5001 : 0,
                },
                'otis-region' : {
                    role : 'manager',
                    custom_otis_gearless : 1,
                    download_cad : 1,
                    download_3d : 0,
                    no_stock : 0,
                    can_purchase : 1,
                    allow_5001 : 0,
                },
                'schindler-branch' : {
                    role : 'customer',
                    custom_otis_gearless : 0,
                    download_cad : 1,
                    download_3d : 0,
                    no_stock : 0,
                    can_purchase : 0,
                    allow_5001 : 0,
                },
                'tke-branch' : {
                    role : 'customer',
                    custom_otis_gearless : 0,
                    download_cad : 1,
                    download_3d : 0,
                    no_stock : 0,
                    can_purchase : 0,
                    allow_5001 : 0,
                },
                'kone-branch' : {
                    role : 'customer',
                    custom_otis_gearless : 1,
                    download_cad : 1,
                    download_3d : 0,
                    no_stock : 1,
                    can_purchase : 0,
                    allow_5001 : 0,
                    manager : 'KoneOps',
                },
            },
            components: [
                { value: 'roller_carside', name: 'Roller Guide Car Side' },
                { value: 'roller_cwtside', name: 'Roller Guide CWT Side' },
                { value: 'governor', name: 'Governor 12' },
                { value: 'governor_ts', name: 'Governor Tension Sheave' },
                { value: 'oilbuffer_carside', name: 'Oil Buffer Car Side' },
                { value: 'oilbuffer_cwtside', name: 'Oil Buffer CWT Side' },
                { value: 'wedge_socket_carside_1', name: 'Wedge Socket Car Side' },
                { value: 'wedge_socket_cwtside_1', name: 'Wedge Socket Cwt Side' },
                { value: 'wedge_socket_cwtside_3', name: 'Wedge Socket Spring CWT Side' },
                { value: 'spring', name: 'Wedge Socket Spring CWT Side' },
                { value: 'light_curtain', name: 'Light Curtain' },
                { value: 'hoist_rope', name: 'Hoist Rope' },
                { value: 'governor_rope', name: 'Governor Rope' },
                { value: 'compensation_chain', name: 'Compensation' },
                { value: 'rope_lubricator', name: 'Rope Lubricator' }
            ],
            special_pdfs: [{ id: '', path: '', orientation: 'L' }],
            machine_type_pdfs: [{ id: '', machine: '', path: '', orientation: 'L' }],
            to_delete_pdfs: [],
            password_validation: {
                char_length: false,
                lowercase: false,
                uppercase: false,
                digit: false,
                special_char: false
            },
            isSendingResetLink: false,
            isSesSupport: false
        }
    },
    created() {
        var user = localStorage.getItem('user');
        if ( !user ) this.$router.push('login');
        this.user = JSON.parse(user);
        this.checkIfSesSupport()
        this.user_id = this.$route.params.id;
        if ( this.user_id > 0 ) this.getUser(this.user_id);
        else this.getOptions();
    },
    methods: {
        checkIfSesSupport() {
            this.isSesSupport = this.user.role === 'ses-support'
        },
        specialDefaults() {
            if ( this.model.special_role && this.role_defaults[this.model.special_role] ) {
                this.model = { ...this.model, ...this.role_defaults[this.model.special_role] };
            }
        },
        getUser(user_id) {
            const api = this.apiUrl+'user/'+user_id;
            this.isLoading = true;
            this.$http.get(api).then((response) => {
                this.isLoading = false;
                this.model = response.data.user;
                this.model.components = this.model.components ? this.model.components.split(',') : [];

                if(this.model.special_pdfs.length > 0) {
                    this.special_pdfs = this.model.special_pdfs;
                } else {
                    this.special_pdfs = [{ id: '', path: '', orientation: 'L' }];
                }

                if(this.model.machine_type_pdfs.length > 0) {
                    this.machine_type_pdfs = this.model.machine_type_pdfs;
                } else {
                    this.machine_type_pdfs = [{ id: '', machine: '', path: '', orientation: 'L' }];
                }

                this.managers = response.data.managers;
                this.roles = response.data.roles;
                this.pms = response.data.pms;
                this.distributors = response.data.distributors;
            });
        },
        checkData(){
            var hasEmpty = false,
                firstEl = false,
                item = false;

            for(var i in this.$refs) {
                const _el = this.$refs[i];
                if ( Array.isArray(_el) ) {
                    for (var x in _el) {
                        item = _el[x];
                        if ( item && item.required && !item.disabled && (item.value == '' || item.value == undefined) ) {
                            hasEmpty = true;
                            if ( !firstEl ) firstEl = item;
                        }
                    }
                } else {
                    item = _el;
                    if ( item && item.required && !item.disabled && (item.value == '' || item.value == undefined) ) {
                        hasEmpty = true;
                        if ( !firstEl ) firstEl = item;
                    }
                }
            }

            if ( hasEmpty ) {
                alert('Please fill all required data.');
                firstEl.focus();
                return false;
            }
            return true;
        },
        getOptions() {
            const api = this.apiUrl+'user/47';
            this.$http.get(api).then((response) => {
                this.managers = response.data.managers;
                this.roles = response.data.roles;
                this.pms = response.data.pms;
                this.distributors = response.data.distributors;
            });
        },
        getPM() {
            return this.managers.map(function(o){
                if ( o.role == "project-manager" ) return o;
            });
        },
        submit_form() {
            const api = this.apiUrl+'save-user/'+this.user_id;
            let fdata = new FormData();
            this.isSubmitting = true;
            if ( !this.checkData() ) return false;

            this.model.password = this.password;
            this.model.password_v = this.password_v;

            if ( this.model.password && this.model.password != this.model.password_v ) {
                alert('Password mismatch.');
                this.isSubmitting = false;
                return false;
            }

            this.model.components = this.model.components.join(',');

            for(let n in this.special_pdfs) {
                let file = '';
                if(this.$refs[`special_pdf_file${n}`]) {
                    if(this.$refs[`special_pdf_file${n}`][0]) {
                        file = this.$refs[`special_pdf_file${n}`][0].files[0];
                    }
                }
                fdata.append(`special_pdf_id[${n}]`, this.special_pdfs[n].id);
                fdata.append(`special_pdf_orientation[${n}]`, this.special_pdfs[n].orientation);
                fdata.append(`special_pdf_file[${n}]`, file);
            }

            for(let n in this.machine_type_pdfs) {
                let file = '';
                if(this.$refs[`machine_type_pdf_file${n}`]) {
                    if(this.$refs[`machine_type_pdf_file${n}`][0]) {
                        file = this.$refs[`machine_type_pdf_file${n}`][0].files[0];
                    }
                }
                fdata.append(`machine_type_pdf_id[${n}]`, this.machine_type_pdfs[n].id);
                fdata.append(`machine_type_pdf_machine[${n}]`, this.machine_type_pdfs[n].machine);
                fdata.append(`machine_type_pdf_orientation[${n}]`, this.machine_type_pdfs[n].orientation);
                fdata.append(`machine_type_pdf_file[${n}]`, file);
            }

            for(let n in this.to_delete_pdfs) {
                fdata.append(`to_delete_pdfs[${n}]`, this.to_delete_pdfs[n]);
            }

            for(let n in this.model) {
                fdata.append(n, this.model[n]);
            }

            this.$http.post(api, fdata, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then((response) => {
                    this.isSubmitting = false;
                    this.xxx = response.data;
                    if ( response.data.status == 'failed' ) {
                        alert(response.data.msg);
                    } else {
                        alert('Saved!');
                        if ( this.user_id == 'new' ) this.$router.push(response.data.id);
                        this.getUser(this.user_id);
                    }
                    this.model.components = this.model.components.split(',');
                })
                .catch(() => {
                    this.isSubmitting = false;
                    alert('Something went wrong!');
                });
        },
        generate_password() {
            const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()-+=<>';
            let result = '';
            for(let i = 0; i < 16; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            this.password = result;
            this.password_v = result;
            this.validate_password();
        },
        select_all_components(e) {
            this.model.components = [];
            if(e.target.checked) {
                for(let n in this.components) {
                    this.model.components.push(this.components[n].value);
                }
            }
        },
        select_component(e) {
            if(e.target.checked) {
                if(this.model.components.indexOf(e.target.value) == -1) {
                    this.model.components.push(e.target.value);
                }
            } else {
                this.model.components.splice( this.model.components.indexOf(e.target.value), 1 );
            }
        },
        add_pdf_row(type) {
            this[`${type}_pdfs`].push({ id: '', path: '', orientation: 'L' });
        },
        remove_pdf_row(type, id, key) {
            this[`${type}_pdfs`].splice(key, 1);
            if(this[`${type}_pdfs`].length == 0) {
                this[`${type}_pdfs`] = [{ id: '', machine: '', path: '', orientation: 'L' }];
            }
            if(id) {
                this.to_delete_pdfs.push(id);
            }
        },
        validate_password() {
            if(this.password.length >= 8) {
                this.password_validation.char_length = true
            } else {
                this.password_validation.char_length = false
            }

            if((/[a-z]/.test(this.password))) {
                this.password_validation.lowercase = true
            } else {
                this.password_validation.lowercase = false
            }

            if((/[A-Z]/.test(this.password))) {
                this.password_validation.uppercase = true
            } else {
                this.password_validation.uppercase = false
            }

            if((/[0-9]/.test(this.password))) {
                this.password_validation.digit = true
            } else {
                this.password_validation.digit = false
            }

            if((/[~`!@#$%^&*()\-_+={}[\]|\\:;"'<>,.?/]/.test(this.password))) {
                this.password_validation.special_char = true
            } else {
                this.password_validation.special_char = false
            }
        },
        handleSendResetLink() {
          this.isSendingResetLink = true;
          this.isSubmitting = true;
          this.$http.post('/api/user-reset-link', { username: this.model.username }).then(() => {
            this.isSendingResetLink = false;
            this.isSubmitting = false;
          }).catch(() => {
            this.isSendingResetLink = false;
            this.isSubmitting = false;
            alert('Sending reset link failed');
          });
        },
        handleHplChange(event) {
            const isChecked = event.target.checked
            this.model.hyperion_price_list = isChecked ? 1 : 0;
        }
    }
};
</script>
<style lang="scss" scoped>
    .personal-fields { margin-top: 51px; }
    .admin-fields { border: 1px solid #000; }
    .admin-fields h3 {background: #000; color: #fff; font-weight: normal; font-size: 15px; text-transform: uppercase; padding: 6px 15px; margin: 0 -15px 15px; }
    .ul-components {
        padding-left: 0.5em;
        li {
            label {
                font-weight: normal;
            }
        }
    }
    .table {
        width: 100%;
        th, td {
            padding: 0.5em;
        }
    }
    .btnAddPdfRow, .btnRemovePdfRow, .btnEditFile {
        font-size: 11px;
        border-radius: 50%;
        height: 24px;
        width: 28px;
        padding: 0;
        float: right;
    }
    .btnAddPdfRow {
        background-color: #459e45;
        color: #fff;
        &:hover {
            color: #000;
        }
    }
    .fa-file-pdf {
        font-size: 30px;
    }
    .pdf-link {
        border: 1px solid #f2f2f2;
        border-radius: 4px;
        width: 160px;
        padding: 0.5em;
        overflow: hidden;
        white-space: nowrap;
    }
    .row-btns {
        width: 60px;
        min-height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .validation {
        color: #404040;
        .fa-check-circle {
            color: #459e45;
        }
        .fa-circle {
            color: #e6e6e6;
        }
    }
    .setting_hpl {
        margin-left: 5px;
    }
</style>
